module.exports = __webpack_public_path__ + "static/media/version_lite.9514780e.svg";